import { Trophy } from "lucide-react";
import SectionHead from "./SectionHead";
import Icon from "./Icon";

export default function Rating({ rating }) {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <SectionHead eyebrow={rating.eyebrow} title={rating.title} sub={rating.subtitle} />

        <div className="grid grid-cols-1 gap-4 mb-5 md:grid-cols-3">
          {rating.criteria.map((r, i) => (
            <div key={i} className="rounded-2xl p-7 border-[1.5px] border-transparent transition-all hover:-translate-y-1"
              style={{ background: r.bg }}>
              <div className="mb-3 text-2xl">
                <Icon name={r.icon} size={28} color={r.color} />
              </div>
              <div className="font-extrabold text-2xl mb-2 tracking-tight" style={{ color: r.color }}>
                {r.ball}
              </div>
              <div className="font-bold text-gray-900 mb-1.5">{r.title}</div>
              <div className="text-gray-400 text-sm leading-relaxed">{r.desc}</div>
            </div>
          ))}
        </div>

        {/* Grand banner */}
        <div className="dc-grand-banner">
          <Trophy size={36} color="#fff" strokeWidth={2} className="flex-shrink-0" />
          <div className="flex-1">
            <div className="font-extrabold text-white text-lg mb-1">{rating.grandTitle}</div>
            <div className="text-amber-100 text-sm leading-relaxed">{rating.grandDesc}</div>
          </div>
          <a href="#apply" className="bg-white text-amber-600 font-extrabold px-5 py-2.5 rounded-xl text-sm flex-shrink-0">
            {rating.grandBadge}
          </a>
        </div>
      </div>
    </section>
  );
}